import React from 'react';
import { ShoppingBag, ArrowRight, FileText } from 'lucide-react';
import coconut from '../../assets/ceylon apparel house.webp';

const ApparelHome = ({ company = {} }) => {
  // Asset Fallbacks using Unsplash for reliable rendering
  const COCONUT_IMAGE = coconut;

  // Inline hero icon - Black/Silver theme
  const getHeroIcon = (companyId, size = 120) => {
    const icons = {
      apparel: (
        <img
          src={COCONUT_IMAGE}
          alt="Coconut Products"
          className={`w-[${size / 8}] h-[${size / 8}] max-w-[${size}px] max-h-[${size}px] drop-shadow-2xl object-contain`}
          onError={(e) => { e.target.src = 'https://via.placeholder.com/160?text=Apparel'; }}
        />
      )
    };

    return icons[companyId] || (
      <div className="p-8 bg-gray-800 rounded-2xl border-4 border-white/10">
        <ShoppingBag size={80} className="text-gray-200 drop-shadow-2xl" />
      </div>
    );
  };

  return (
    <div className="animate-in fade-in duration-700 bg-black">
      <section className="bg-gradient-to-br from-gray-950 via-slate-900 to-black py-24 px-6 relative overflow-hidden min-h-[80vh] flex items-center">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-slate-400/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gray-600/5 blur-[120px] rounded-full translate-y-1/2 -translate-x-1/2"></div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10">
          <div className="space-y-10">
            <div className="space-y-4">
              <span className="text-gray-400 font-bold tracking-[0.4em] text-xs uppercase block px-1">Industrial Excellence</span>
              <h2 className="text-5xl lg:text-7xl font-black leading-[1.1] bg-gradient-to-r from-white via-gray-100 to-gray-400 bg-clip-text text-transparent drop-shadow-2xl">
                Precision <span className="text-transparent bg-gradient-to-r from-gray-400 to-gray-600 bg-clip-text">Craftsmanship</span>, Global Scale.
              </h2>
            </div>

            <div className="relative">
              <div className="absolute -left-4 top-0 bottom-0 w-1 bg-gradient-to-b from-gray-400 to-transparent opacity-30"></div>
              <p className="text-lg md:text-xl text-gray-400 leading-relaxed pl-6 max-w-lg">
                {company.description || "Vertically integrated manufacturing delivering excellence."} From high-tech concept development to global consumer logistics.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-5">
              <button className="group relative px-10 py-6 bg-white text-black rounded-2xl font-black text-lg transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 overflow-hidden shadow-[0_0_40px_rgba(255,255,255,0.15)]">
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 to-white opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <span className="relative flex items-center gap-2">
                  View Collections <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </button>

              <button className="px-10 py-6 border-2 border-gray-700 text-gray-300 rounded-2xl font-black text-lg hover:bg-white/5 hover:border-gray-400 hover:text-white transition-all duration-300 backdrop-blur-sm flex items-center justify-center gap-3 group">
                <FileText size={20} className="text-gray-500 group-hover:text-white transition-colors" />
                Get Quote
              </button>
            </div>
          </div>

          <div className="hidden md:flex justify-center relative">
            {/* Multi-layered container for the icon/image */}
            <div className="w-96 h-96 relative group flex items-center justify-center">
              {/* Animated Glow Backdrops */}
              <div className="absolute inset-0 bg-white/5 blur-[100px] rounded-full opacity-0 group-hover:opacity-100 transition-all duration-1000 animate-pulse"></div>

              {/* Main Card */}
              <div className="w-96 h-96 bg-gradient-to-br from-gray-900 to-black backdrop-blur-2xl rounded-[3.5rem] shadow-2xl flex items-center justify-center border border-white/10 relative transition-all duration-700 group-hover:scale-105 group-hover:rotate-2 group-hover:border-white/20">
                <div className="absolute inset-4 rounded-[2.8rem] border border-white/5 bg-gradient-to-tr from-transparent via-white/5 to-transparent pointer-events-none"></div>
                <div className="  relative">
                  {getHeroIcon(company.id, 120)}
                </div>
              </div>

              {/* Decorative side elements */}
              <div className="absolute top-20 -right-4 w-12 h-12 bg-gray-800 border border-white/10 rounded-xl flex items-center justify-center text-gray-400 transition-all duration-500 group-hover:translate-x-4">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>
              <div className="absolute bottom-20 -left-4 w-16 h-16 bg-gray-900 border border-white/10 rounded-2xl flex items-center justify-center text-gray-400 transition-all duration-500 group-hover:-translate-x-4 delay-75">
                <div className="w-8 h-1 bg-white/10 rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApparelHome;